<template>
    <div id="destinos">
        <div class="container-fluid">
            <div class="row main-content">
                <div class="small-title-top pull-left">
                    <h4 v-html="state.title"></h4>
                    <hr>
                </div>
                <div class="destinos-main-container" data-aos="fade-right">
                    <h1>{{state.dubtitle1}}</h1>
                </div>
                <div class="col-md-12 map-container" style="pointer-events:none;" data-aos="fade-up">
                    <iframe src="https://www.google.com/maps/d/embed?mid=1uHvvRmH8YR8j0hS4uxjoAYqrw_w&hl=es" width="100%" height="750" frameborder="0" style="border:0 pointer-events:none;" allowfullscreen></iframe>
                </div>
                <div class="col-md-5 pull-right cornered" data-aos="fade-right">
                    <div class="info-container">
                        <hr>
                        <h4 class="small-title" v-html="state.title"></h4>
                        <h1>{{state.subTitle2}}</h1>
                        <p style="font-size:15pt;">{{state.pTextTop}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 footer-container" style="padding:20px;">
            <router-link to="/contacto" tag="a">
                <h3>{{this.$store.state.activeList.footerPage.title}}</h3>
            </router-link>
            <hr style="border-top:1px solid white;">
            <p>Copyright @2017 - All Rights Reserved</p>
        </div>
    
    </div>
</template>

<script>
export default {

    methods: {
    },
    components: {
    },
    computed: {
        state(){
            return this.$store.state.activeList.mapDest
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.footer-container {
    background-color: $gris;
    color: white;
    padding: 20px;
}

a {
    color: white;
}

.main-content {
    display: block;
    color: $gris;
}

.map-container {}



hr {
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 20%;
    border-top: 2px solid $azul;
    margin: 1em 1em;
    padding: 0;
}

h1 {
    color: white;
    font-size: 40pt;
}

img {
    width: 100%;
}

.text-container {
    text-align: right;
    margin-top: 5%;
}

.small-title {
    width: 370px;
    text-align: right;
    vertical-align: middle;
    font-size: 21px!important;
}

.info-container h4 {
    display: inline-block;
}

.info-container hr {
    display: inline-block;
    display: inline-block;
    vertical-align: middle;
    height: 2px;
    border: 0;
    width: 30%;
    border-top: 2px solid $azul;
    margin: 1em 1em;
    padding: 0;
}

.small-title-top {
    margin-top: 150px;
    width: 100%;
    text-align: left;
    vertical-align: middle;
    padding: 80px;
}

.small-title-top hr {
    border-top: 2px solid $rojo;
}

.info-container {
    color: white;
    text-align: right;
    position: absolute;
    padding: 40px;
}

h4 {
    display: inline-block;
}

.cornered {
    width: 50%;
    margin-top: -550px;
    box-sizing: border-box;
    border-bottom: 24em solid $rojo;
    border-left: 7em solid transparent;
}

.destinos-main-container {
    text-align: left;
    padding: 80px;
}

.destinos-main-container h1 {
    color: $azul!important;
    font-size: 80pt;
}

@media screen and (max-width:1230px) {


    .small-title-top {

        padding: 25px;
    }
    h1 {
        font-size: 40pt!important;
    }

    .cornered {
        width: 100%;
        box-sizing: none;
        border-bottom: 0em solid $rojo;
        border-left: 0em solid transparent;
        margin-top: 0px;
    }

    .col-md-5 {
        padding: 0!important;
    }

    .info-container {
        color: white;
        display: block;
        text-align: left;
        position: relative;
        float: left;
        padding: 20px;
        background-color: $rojo;
    }
}
</style>



// WEBPACK FOOTER //
// destinos.vue?f8e78da0